import course1 from "../assets/media/photos/skyford_gallery_photo_6.webp";
import course2 from "../assets/media/photos/skyford_gallery_photo_18.webp";
import course3 from "../assets/media/photos/skyford_gallery_photo_23.webp";
import course4 from "../assets/media/photos/skyford_gallery_photo_5.webp";
import course5 from "../assets/media/photos/skyford_gallery_photo_19.webp";
import course6 from "../assets/media/photos/skyford_gallery_photo_13.webp";
import course7 from "../assets/media/photos/skyford_gallery_photo_7.webp";
import course8 from "../assets/media/photos/skyford_gallery_photo_20.webp";
import course9 from "../assets/media/photos/skyford_gallery_photo_18.webp";
import course10 from "../assets/media/photos/skyford_gallery_photo_20.webp";


const courseData = [
    {
      id: 1,
      title: "Advanced Diploma in Global Hospitality and Aviation Management",
      type: "Diploma",
      isNew: false,
      image: course1,
      description:
        "This Advanced Diploma in Global Hospitality and Aviation Management is designed for students who want to build a career in the aviation, travel, and hospitality industries. The program combines theoretical knowledge with practical training, covering airport operations, customer service, and reservation systems. With international exposure, including an internship at SEGi University, Malaysia, students gain real-world experience and industry-ready skills.",
      // duration: "2 years",
      // certificates: 10,
      contents: [
  "Two IATA Certifications",
  "Three Computer Reservation Systems",
  "Diploma in Aviation and Hospitality Management",
  "Diploma in Airport Management",
  "International Airport Training",
  "International Study Tour",
  "Communicative English and Personality Development"
],
highlights:[
    "Internship opportunity in Malaysia",
  "Cultural Exchange Program",
  "Workshops and Group Discussions",
  "Certification from SEGi University, Malaysia",
  "Industrial Visits and Field Trips in Malaysia",
  "Professional Growth and Career Enhancement Sessions",
  "Hospitality Simulations and Presentation Training"
        ]
  },
{
  id: 2,
  title: "Advanced Diploma in Global Hospitality and Cabin Crew Management",
  type: "Diploma",
  isNew: false,
  image: course9, // you didn’t give path, so keep placeholder
 description: "An industry-oriented advanced diploma that equips aspiring professionals with the skills and international exposure required for aviation and hospitality careers, including certified training, real-world simulations, and an internship opportunity at SEGi University, Malaysia.",
  contents: [
    "One IATA Certification",
    "One Computer Reservation System",
    "Diploma in Aviation and Hospitality Management",
    "Diploma in Cabin Crew Management",
    "Diploma in Airport Management",
    "International Airport Training",
    "International Study Tour",
    "Communicative English and PD"
  ],

  highlights: [
    "Internship at Malaysia",
    "Cultural Exchange Program",
    "Workshops and Group Discussions",
    "Certification – SEGi University, Malaysia",
    "Industrial Visit and Field Trip at Malaysia",
    "Professional Growth and Career Enhancement",
    "Hospitality Simulations and Presentation Sessions"
  ]
},
    {
      id: 3,
      title: "Diploma in Aviation and Hospitality Management",
      type: "Diploma",
      isNew: false,
      image: course2,
      description:"This diploma program equips students with essential skills and knowledge in aviation and hospitality, including airport operations, customer service, and reservation systems. It focuses on practical training and industry exposure to prepare students for careers in airlines, airports, and the global hospitality sector.",
      // duration: "2 years",
      // certificates: 10,
      contents: [
  "Two IATA Certifications",
  "Three Computer Reservation Systems",
  "Diploma in Aviation and Hospitality Management",
  "Diploma in Airport Management",
  "International Airport Training",
  "International Study Tour",
  "Communicative English and Personality Development"
],
  },
    {
      id: 4,
      title: "Diploma in Aviation And Tourism Management",
      type: "Diploma",
      isNew: false,
      image: course10,
      description:
        "The aviation and tourism management diploma course integrates aviation principles with tourism expertise, providing students a comprehensive understanding to excel in managing diverse aspects of the aviation and tourism industry.",
      // duration: "1 year",
      // certificates: 6,
      contents: [
        "One IATA Certification",
        "One Computer Reservation System",
        "Diploma in Aviation, Travel and Tourism Management",
        "Diploma in Airport Management",
        "Communicative English and PD",
      ],
    },


  {
  id: 5,
  title: "Diploma in Aviation and Logistics Management",
  type: "Diploma",
  isNew: false,
  image: course3,
  description: "This diploma program focuses on aviation and logistics management, covering supply chain operations, cargo handling, and airport management. It equips students with practical skills and industry knowledge required for careers in aviation, logistics, and global transportation sectors.",
  contents: [
    "One IATA Certification",
    "Diploma in Logistics and Supply Chain Management",
    "Diploma in Airport Management",
    "Diploma in Cargo Introductory",
    "International Airport Training",
    "International Study Tour",
    "Communicative English and PD"
  ],
  highlights: []
},
{
  id: 6,
  title: "MBA in Global Hospitality and Aviation Management",
  subtitle:"With Internship at SEGi University, Malaysia",
  type: "MBA",
  isNew: false,
  image: course4,
  description: "This MBA program in Global Hospitality and Aviation Management is designed to develop advanced managerial and operational skills in the aviation and hospitality industries. It combines academic learning with practical exposure, including international internship opportunities, preparing students for leadership roles in global organizations.",

  contents: [
    "Two IATA Certifications",
    "Three Computer Reservation Systems",
    "Diploma in Aviation and Hospitality Management",
    "Diploma in Airport Management",
    "International Airport Training",
    "International Study Tour",
    "Communicative English and PD"
  ],

  highlights: [
    "Internship at Malaysia",
    "Cultural Exchange Program",
    "Workshops and Group Discussions",
    "Certification – SEGi University, Malaysia",
    "Industrial Visit and Field Trip at Malaysia",
    "Professional Growth and Career Enhancement",
    "Hospitality Simulations and Presentation Sessions"
  ]
},
{
  id: 7,
  title: "BBA in Global Hospitality and Aviation Management",
  type: "BBA",
  isNew: false,
  image: course5,
  description: "This BBA program in Global Hospitality and Aviation Management focuses on building strong foundational knowledge in business, aviation, and hospitality operations. It combines academic learning with practical exposure, including international internship opportunities, preparing students for careers in airline management, airport operations, and the global hospitality industry.",
  contents: [
    "Two IATA Certifications",
    "Three Computer Reservation Systems",
    "Diploma in Aviation and Hospitality Management",
    "Diploma in Airport Management",
    "International Airport Training",
    "International Study Tour",
    "Communicative English and PD"
  ],

  highlights: [
    "Internship at Malaysia",
    "Cultural Exchange Program",
    "Workshops and Group Discussions",
    "Certification – SEGi University, Malaysia",
    "Industrial Visit and Field Trip at Malaysia",
    "Professional Growth and Career Enhancement",
    "Hospitality Simulations and Presentation Sessions"
  ]
},
{
      id: 8,
      title: "BBA in Aviation And Artificial Intelligence",
      type: "BBA",
      image: course6,
      isNew: false,
      description:
        "In airport operations, artificial intelligence streamlines tasks like security checks and baggage handling, improving efficiency and passenger experience by automating processes and enhancing overall safety and security measures.",
      // duration: "3 years",
      // certificates: 10,
      contents: [
        "Two IATA Certifications",
        "Three Computer Reservation Systems",
        // "Three Computer Reservation System (Galileo, Amadeus, Sabre)",
        "Diploma in Aviation and Hospitality Management",
        "Diploma in Airport Management",
        "Diploma in Artificial Intelligence",
        "International Airport Training",
        "International Study Tour",
        "Communicative English and PD",
      ],
    },

        {
      id: 9,
      title: "BBA in Aviation And Hospitality Management",
      type: "BBA",
      isNew: false,
      image: course7,
      description:
        "The aviation and hospitality management course integrates airline operations and hospitality expertise, preparing students for careers in managing diverse aspects of the aviation and travel industry, from logistics to customer service.",
      // duration: "3 years",
      // certificates: 10,
      contents: [
        "Two IATA Diploma Certifications",
        "Three Computer Reservation Systems",
        // "Three Computer Reservation System (Galileo, Amadeus, Sabre)",
        "Diploma in Aviation and Hospitality Services",
        "Diploma in Aviation,Travel and Tourism Management",
        "Diploma in Airport Management",
        "International Airport Training",
        "International Study Tour",
        "Communicative English And PD",
      ],
    },
        {
      id: 10,
      title: "BBA in Aviation And Logistics Management",
      type: "BBA",
      isNew: false,
      image: course8,
      description:
        "The aviation and logistics management course combines aviation industry knowledge with logistics expertise, providing students with skills to manage supply chains, operations, and logistics within the aviation sector.",
      // duration: "3 years",
      // certificates: 6,
      contents: [
        "One IATA Diploma Certifications",
        "Diploma in Logistics and Supply Chain Management",
        "Diploma in Cargo Introductory",
        "Diploma in Airport Management",
        "International Airport Training",
        "International Study Tour",
        "Communicative English and PD",
      ],
    },



  //⚠️⚠️⚠️ TEMPLATE ⚠️⚠️⚠️
//   {
//   id: 0,
//   title: "SET_TITLE",
//   type: "SET_TYPE",
//   isNew: false,
//   image: "SET_IMAGE",
//   description: "SET_DESCRIPTION",

//   contents: ["SET_CONTENT"],
//   highlights: ["SET_HIGHLIGHT"]
// }














    // {
    //   id: 1,
    //   title: "Aviation, Artificial Intelligence & Data Science",
    //   type: "MBA",
    //   isNew: false,
    //   image: course7,
    //   description:
    //     "In airport operations, artificial intelligence streamlines tasks like security checks and baggage handling, improving efficiency and passenger experience by automating processes and enhancing overall safety and security measures.",
    //   duration: "2 years",
    //   certificates: 10,
    //   contents: [
    //     "Two IATA Diploma Certificates",
    //     "Three Computer Reservation System (Galileo, Amadeus, Sabre)",
    //     "Diploma in Aviation and Travel Management",
    //     "Diploma in Airport Management",
    //     "Diploma in Artificial Intelligence",
    //     "International Airport Training",
    //     "Communicative English & PD",
    //     "International Study Tour",
    //   ],
    //   highlights:[
    //         "Two IATA Certifications",
    // "Three Computer Reservation Systems",
    // "Diploma in Aviation and Hospitality Management",
    // "Diploma in Airport Management",
    // "International Airport Training",
    // "International Study Tour",
    // "Communicative English and PD"
    //   ]
    // },
    // {
    //   id: 2,
    //   title: "Aviation & Logistics Management",
    //   type: "MBA",
    //   isNew: false,
    //   image: course8,
    //   description:
    //     "The aviation and logistics management course combines aviation industry knowledge with logistics expertise, providing students with skills to manage supply chains, operations, and logistics within the aviation sector.",
    //   duration: "2 years",
    //   certificates: 10,
    //   contents: [
    //     "Two IATA Diploma Certificates",
    //     "Three Computer Reservation System (Galileo, Amadeus, Sabre)",
    //     "Diploma in Aviation and Travel Management",
    //     "Diploma in Airport Management",
    //     "Diploma in Artificial Intelligence",
    //     "International Airport Training",
    //     "Communicative English & PD",
    //     "International Study Tour",
    //   ],
    // },

    // {
    //   id: 4,
    //   title: "Aviation & Hospitality Management",
    //   type: "BBA",
    //   isNew: true,
    //   image: course2,
    //   description:
    //     "The aviation and hospitality management course integrates airline operations and hospitality expertise, preparing students for careers in managing diverse aspects of the aviation and travel industry, from logistics to customer service.",
    //   duration: "3 years",
    //   certificates: 10,
    //   contents: [
    //     "Two IATA Diploma Certificates",
    //     "Three Computer Reservation System (Galileo, Amadeus, Sabre)",
    //     "Diploma in Aviation & Hospitality Services",
    //     "Diploma in Airport Management",
    //     "Diploma in Aviation and Travel Management",
    //     "International Airport Training",
    //     "Communicative English & PD",
    //     "International Study Tour",
    //   ],
    // },
    // {
    //   id: 5,
    //   title: "Aviation & Logistics Management",
    //   type: "BBA",
    //   isNew: true,
    //   image: course3,
    //   description:
    //     "The aviation and logistics management course combines aviation industry knowledge with logistics expertise, providing students with skills to manage supply chains, operations, and logistics within the aviation sector.",
    //   duration: "3 years",
    //   certificates: 6,
    //   contents: [
    //     "One IATA Diploma Certificate",
    //     "Diploma in Logistics and Supply Chain Management",
    //     "Diploma in Cargo Introductory",
    //     "Diploma in Airport Management",
    //     "International Airport Training",
    //     "Communicative English & PD",
    //     "International Study Tour",
    //   ],
    // },
    // {
    //   id: 6,
    //   title: "Cabin Crew & Hospitality Management",
    //   type: "Diploma",
    //   isNew: false,
    //   image: course4,
    //   description:
    //     "The cabin crew and hospitality management course equips individuals with the skills needed for a career in the aviation industry, focusing on service excellence, safety, and customer satisfaction.",
    //   duration: "1 year",
    //   certificates: 6,
    //   contents: [
    //     "One IATA Diploma Certificates",
    //     "Computer Reservation System (Galileo or Sabre)",
    //     "Diploma in Aviation and Hospitality Management",
    //     "Diploma in Cabin Crew Management",
    //     "Diploma in Airport Management",
    //     "International Airport Training",
    //     "Communicative English & PD",
    //     "International Study Tour",
    //   ],
    // },
    // {
    //   id: 7,
    //   title: "Aviation & Hospitality Management",
    //   type: "Diploma",
    //   isNew: false,
    //   image: course5,
    //   description:
    //     "The aviation and hospitality management diploma course offers a comprehensive program, blending aviation industry insights with hospitality skills, preparing students for diverse roles in managing customer service and operations.",
    //   duration: "1 year",
    //   certificates: 8,
    //   contents: [
    //     "Two IATA Diploma Certificates",
    //     "Three Computer Reservation System (Galileo, Amadeus, Sabre)",
    //     "Diploma in Aviation & Hospitality Services",
    //     "Diploma in Airport Management",
    //     "International Airport Training",
    //     "Communicative English & PD",
    //     "International Study Tour",
    //   ],
    // },
    // {
    //   id: 8,
    //   title: "Aviation & Tourism Management",
    //   type: "Diploma",
    //   isNew: false,
    //   image: course6,
    //   description:
    //     "The aviation and tourism management diploma course integrates aviation principles with tourism expertise, providing students a comprehensive understanding to excel in managing diverse aspects of the aviation and tourism industry.",
    //   duration: "1 year",
    //   certificates: 6,
    //   contents: [
    //     "One IATA Diploma Certificate",
    //     "2 Computer Reservation System (Galileo and Sabre)",
    //     "Diploma in Aviation and Travel & Tourism",
    //     "Diploma in Airport Management",
    //   ],
    // },
    // {
    //   id: 9,
    //   title: "Aviation & Logistics Management",
    //   type: "Diploma",
    //   isNew: false,
    //   image: course9,
    //   description:
    //     "The logistics and supply chain management diploma course equips students with skills to efficiently manage the movement of goods, streamline processes, and enhance supply chain operations in various industries.",
    //   duration: "1 year",
    //   certificates: 5,
    //   contents: [
    //     "One IATA Diploma Certificate",
    //     "Diploma in Logistics and Supply Chain Management",
    //     "Diploma in Cargo Introductory",
    //     "Diploma in Airport Management",
    //     "International Airport Training",
    //     "Communicative English & PD",
    //     "International Study Tour",
    //   ],
    // },
    
  ];
  
  export default courseData;

















  // {
    //   id: 10,
    //   title: "Airport Management",
    //   type: "Diploma",
    //   isNew: false,
    //   image: course1,
    //   description:
    //     "The airport management diploma course focuses on developing skills in airport operations, safety, and administration, preparing students for key roles in efficiently managing and overseeing airport facilities and services",
    //   duration: "6 months",
    //   certificates: 2,
    //   contents: [
    //     "1 International Diploma Certificate",
    //     "Diploma in Airport Management",
    //   ],
    // },
    // {
    //   id: 11,
    //   title: "Logistics Management",
    //   type: "Diploma",
    //   isNew: false,
    //   image: course1,
    //   description:
    //     "The logistics management diploma course provides a comprehensive understanding of supply chain operations, transportation, and inventory management, preparing students for dynamic roles in optimizing and streamlining logistical processes.",
    //   duration: "6 months",
    //   certificates: 2,
    //   contents: [
    //     "1 International Diploma Certificate",
    //     "Diploma in Logistics Management",
    //   ],
    // },
    // {
    //   id: 12,
    //   title: "Computer Reservations System",
    //   type: "Diploma",
    //   isNew: false,
    //   image: course1,
    //   description:
    //     "The computer reservations system diploma course in tourism focuses on equipping students with skills to efficiently navigate reservation systems, enhancing their ability to manage bookings and optimize customer experiences in tourism settings.",
    //   duration: "6 months",
    //   certificates: 1,
    //   contents: [
    //     "Specialized training on booking systems",
    //   ],
    // },